import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/modules/services/auth-service/auth.service';
import { UserLanguageService } from 'src/app/modules/services/user-language-service/user-language.service';
import { UserDashboardService } from 'src/app/modules/user-dashboard.service';
import { UserNotificationComponent } from 'src/app/modules/user-notification/user-notification.component';

@Component({
    selector: 'app-main-footer',
    templateUrl: './main-footer.component.html',
    styleUrls: ['./main-footer.component.scss'],
    standalone: false
})
export class MainFooterComponent implements OnInit {
  lang
  langSub: Subscription;

  labels;
  labelsSub: Subscription;

  user
  userSub: Subscription;

  notifications

  homePage
  profilePage
  messagesPage
  faqPage
  calendar
  unsubscribe
  unsub
  msgsNotifications
  backgroundColor
  hasNotifications: boolean
  notificationNumber: Number
  showPhoneIcon

  meeting = []

  userId
  constructor(private authService: AuthService, private router: Router, private languageService: UserLanguageService, private userDashboarService: UserDashboardService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.homePage = "active"
    this.profilePage = "notActive"
    this.messagesPage = "notActive"
    this.faqPage = "notActive"
    this.calendar = "notActive"

    this.langSub = this.languageService.lang$.subscribe((lang) => {
      this.lang = lang;
    })
    this.labelsSub = this.languageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })

    this.userSub = this.authService.user$.subscribe((user) => {
      console.log("*****1******")
      this.user = user;
      console.log(this.user)
      console.log("*****2******")
      this.userDashboarService.fetchUnreadNotifications().subscribe( (result: Notification[]) => {
        this.hasNotifications = result.length > 0;
        this.notificationNumber = result.length;
      })
      setTimeout(() => {
        this.userId = this.user?.userId
        //this.getMessagesNotifications(this.user)
        //this.getUsersChatMeeting(this.user)
        if (this.user.companyId == 1) {
          console.log("IF")
          this.backgroundColor = "#808385"
        } else if (this.user.companyId == 2) {
          this.backgroundColor = "#ffe7ef"
        }
        else {
          this.backgroundColor = "#ffe7ef"
        }
       console.log("meeting from oninit: ", this.meeting)
      }, 500);

    });
  }

  goToMeeting(){
    this.router.navigateByUrl("/user/chat-meeting")
  }

    selectLang(lang) {
      this.languageService.setLanguage(lang);
    }


    logout(): void {
      this.unsub();
      this.authService.logout();
      this.router.navigateByUrl('/');
    }

    changeColor(select: String) {
      switch (select) {
        case "home":
          this.homePage = "active"
          this.profilePage = "notActive"
          this.messagesPage = "notActive"
          this.faqPage = "notActive"
          this.calendar = "notActive"
          break;
        case "profile":
          this.homePage = "notActive"
          this.profilePage = "active"
          this.messagesPage = "notActive"
          this.faqPage = "notActive"
          this.calendar = "notActive"
          break;
        case "messages":
          this.homePage = "notActive"
          this.profilePage = "notActive"
          this.messagesPage = "active"
          this.faqPage = "notActive"
          this.calendar = "notActive"
          break;
        case "faq":
          this.homePage = "notActive"
          this.profilePage = "notActive"
          this.messagesPage = "notActive"
          this.faqPage = "active"
          this.calendar = "notActive"
          break;
        case "notifications":
          this.openNotificationDialog()
          this.homePage = "notActive"
          this.profilePage = "notActive"
          this.messagesPage = "notActive"
          this.faqPage = "notActive"
          this.calendar = "active"
          break;
      }
    }

    openNotificationDialog() {
      const dialogRef = this.dialog.open(UserNotificationComponent, {
        width: '100%',
        height: "95%",
        hasBackdrop: true,
        backdropClass: 'blurBackground'
        });

      dialogRef.afterClosed().subscribe(() => {
        this.userDashboarService.fetchUnreadNotifications().subscribe((result: Notification[]) => {
          this.hasNotifications = result.length > 0;
          this.notificationNumber = result.length;
        });
      })
    }
}
